import { render, staticRenderFns } from "./PersonalProtectiveEquipmentView.vue?vue&type=template&id=341b81d7&"
import script from "./PersonalProtectiveEquipmentView.vue?vue&type=script&lang=js&"
export * from "./PersonalProtectiveEquipmentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports